module.exports = __webpack_public_path__ + "img/logo.60be00f6.svg";